export function initAccordion(options = {}) {
	const { itemSelector = ".js-accordion", contentSelector = ".js-accordion-content", openClass = "open", breakpoint = null, autoOpenFirst = false } = options;

	const items = document.querySelectorAll(itemSelector);
	if (!items.length) return;

	const hasBreakpoint = typeof breakpoint === "number" && breakpoint > 0;
	const mq = hasBreakpoint ? window.matchMedia(`(max-width: ${breakpoint - 1}px)`) : null;

	let isMobile = mq ? mq.matches : true;

	function setOpen(item, open) {
		// const trigger = item.querySelector("a, button, [role='button']") || item;
		item.classList.toggle(openClass, open);
		// trigger.setAttribute("aria-expanded", String(open));
	}

	function closeAll(except = null) {
		items.forEach((item) => {
			if (item !== except) setOpen(item, false);
		});
	}

	function onClick(e) {
		if (hasBreakpoint && !isMobile) return;

		const item = e.target.closest(itemSelector);
		if (!item) return;

		if (e.target.closest(contentSelector)) return;

		e.preventDefault();
		setOpen(item, !item.classList.contains(openClass));
	}

	function onBreakpoint(e) {
		isMobile = e.matches;

		if (isMobile) {
			if (autoOpenFirst) {
				closeAll();
				setOpen(items[0], true);
			}
		} else {
			closeAll();
		}
	}

	if (isMobile && autoOpenFirst) {
		setOpen(items[0], true);
	}

	document.addEventListener("click", onClick);
	if (mq) mq.addEventListener("change", onBreakpoint);

	return () => {
		document.removeEventListener("click", onClick);
		if (mq) mq.removeEventListener("change", onBreakpoint);
	};
}
